<template>
  <section v-if="role === 'super_admin'">
    <AnimatedBox orientation="y">
      <div>
        <!-- Admin / Default View Header -->
        <template v-if="role === 'super_admin'">
          <div class="space-y-3 px-2 pb-4">
            <h1
              class="text-[clamp(1.8rem,2.2vw,2.45rem)] font-extrabold leading-tight text-[#182033]"
            >
              {{ title }}
            </h1>
            <div class="flex flex-row justify-between">
              <p class="max-w-[55rem] text-[0.98rem] leading-7 text-[#6e7b92]">
                {{ subtitle }}
              </p>
              <div
                class="flex flex-wrap items-center justify-end gap-2 max-[860px]:justify-start"
              >
                <Badge
                  variant="outline"
                  class="rounded-full border-[rgba(217,226,238,0.95)] bg-[#edf4ff] px-3 py-1 text-[0.8rem] font-extrabold text-[#2855a6]"
                >
                  Last updated: {{ formattedLastUpdated }}
                </Badge>
                <!-- <Button
                  data-pdf-exclude="true"
                  variant="outline"
                  class="inline-flex min-h-11 items-center gap-2 rounded-[0.95rem] border-[rgba(49,125,255,0.22)] bg-[#f6f9ff] px-[1.05rem] py-[0.7rem] text-[0.88rem] font-bold text-[#2855a6] hover:bg-[#eef4ff]"
                  type="button"
                  @click="$emit('refresh')"
                >
                  <RefreshCcw class="size-4" />
                  Refresh
                </Button>
                <Button
                  v-if="!showReportMenu"
                  data-pdf-exclude="true"
                  class="inline-flex min-h-11 items-center gap-2 rounded-[0.95rem] bg-[#1f7aff] px-[1.05rem] py-[0.7rem] text-[0.88rem] font-bold text-white hover:-translate-y-px hover:bg-[#1f7aff] hover:shadow-[0_12px_24px_rgba(31,122,255,0.24)]"
                  type="button"
                  :disabled="isReportActionBusy"
                  @click="handleDownloadReportClick"
                >
                  <Download v-if="!isReportActionBusy" class="size-4" />
                  <Loader2 v-else class="size-4 animate-spin" />
                  {{
                    isReportActionBusy ? "Preparing report..." : "Download Report"
                  }}
                </Button>

                <details v-else ref="reportMenuRef" class="relative">
                  <summary
                    class="inline-flex min-h-11 items-center gap-2 rounded-[0.95rem] bg-[#1f7aff] px-[1.05rem] py-[0.7rem] text-[0.88rem] font-bold text-white hover:-translate-y-px hover:bg-[#1f7aff] hover:shadow-[0_12px_24px_rgba(31,122,255,0.24)]"
                  >
                    <Download class="size-4" />
                    Download Report
                    <ChevronDown class="size-4" />
                  </summary>

                  <div
                    class="absolute right-0 top-[calc(100%+0.6rem)] z-20 min-w-[18rem] overflow-hidden rounded-[1rem] border border-[rgba(218,226,238,0.98)] bg-white p-2 shadow-[0_24px_50px_rgba(15,23,42,0.16)]"
                  >
                    <button
                      v-for="action in reportActions"
                      :key="action.value"
                      type="button"
                      :disabled="isReportActionBusy"
                      class="flex w-full items-center justify-between rounded-[0.85rem] px-4 py-3 text-left text-[0.88rem] font-semibold text-[#173b5f] hover:bg-[#f6f9ff]"
                      @click="handleReportMenuAction(action.value)"
                    >
                      <span>{{ action.label }}</span>
                      <span
                        class="text-[0.74rem] font-bold uppercase tracking-[0.08em] text-[#748197]"
                      >
                        {{ action.hint }}
                      </span>
                    </button>
                  </div>
                </details> -->
              </div>
            </div>
            <!-- <div
                  v-if="reportPeriod"
                  class="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs font-semibold text-[#6e7b92] pt-0.5"
                >
                  <span
                    class="inline-flex items-center gap-1 rounded-full bg-[#f0f4ff] border border-[#dbe5ff] px-2.5 py-0.5 text-[#2855a6]"
                  >
                    Current Report Period:
                    <span class="font-bold">{{ reportPeriod }}</span>
                  </span>
                  <span
                    v-if="nextReportUpdate"
                    class="inline-flex items-center gap-1 rounded-full bg-slate-50 border border-slate-200 px-2.5 py-0.5 text-slate-500"
                  >
                    Next Report Update:
                    <span class="font-bold text-slate-600">{{
                      nextReportUpdate
                    }}</span>
                  </span>
                </div> -->
          </div>
        </template>
      </div>
    </AnimatedBox>

    <AnimatedBox
      orientation="y"
      :delay="0.08"
    >
      <div
        v-if="showClientSelector"
        class="flex items-center justify-between gap-4 rounded-[1.25rem] border border-[rgba(219,227,239,0.9)] bg-white/94 p-4 shadow-[0_18px_45px_rgba(15,23,42,0.05)] max-[1100px]:flex-col max-[1100px]:items-stretch"
      >
        <div class="grid w-full gap-4 md:grid-cols-2 xl:grid-cols-6">
          <div class="flex flex-col gap-[0.42rem] xl:col-span-2">
            <span
              class="text-[0.75rem] font-extrabold uppercase tracking-[0.08em] text-[#748197]"
            >
              Client
            </span>
            <Select
              :model-value="filters.client_id"
              @update:model-value="onClientUpdate"
            >
              <SelectTrigger
                class="min-h-12 rounded-[0.95rem] border-[rgba(211,220,233,1)] bg-[#fdfefe] px-[0.9rem] py-[0.82rem] text-[0.95rem] text-[#243049] shadow-[inset_0_1px_0_rgba(255,255,255,0.85)] focus:ring-[#8eb4ff] focus:ring-offset-0"
              >
                <SelectValue placeholder="All Clients" />
              </SelectTrigger>
              <SelectContent
                class="rounded-[0.95rem] border-[rgba(211,220,233,1)] bg-white text-[#243049] shadow-[0_20px_45px_rgba(15,23,42,0.12)]"
              >
                <SelectItem value="all">
                  All Clients
                </SelectItem>
                <SelectItem
                  v-for="client in clients"
                  :key="client.id"
                  :value="client.client_id"
                >
                  {{ client.company_name }}
                </SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div class="flex flex-col gap-[0.42rem]">
            <span
              class="text-[0.75rem] font-extrabold uppercase tracking-[0.08em] text-[#748197]"
            >
              Service
            </span>
            <Select
              :model-value="
                filters.service_id === null ? '' : String(filters.service_id)
              "
              @update:model-value="onServiceUpdate"
            >
              <SelectTrigger
                class="min-h-12 rounded-[0.95rem] border-[rgba(211,220,233,1)] bg-[#fdfefe] px-[0.9rem] py-[0.82rem] text-[0.95rem] text-[#243049] shadow-[inset_0_1px_0_rgba(255,255,255,0.85)] focus:ring-[#8eb4ff] focus:ring-offset-0"
              >
                <SelectValue placeholder="All Services" />
              </SelectTrigger>
              <SelectContent
                class="rounded-[0.95rem] border-[rgba(211,220,233,1)] bg-white text-[#243049] shadow-[0_20px_45px_rgba(15,23,42,0.12)]"
              >
                <SelectItem value="__all_services">
                  All Services
                </SelectItem>
                <SelectItem
                  v-for="service in serviceOptions"
                  :key="service.value"
                  :value="service.value"
                >
                  {{ service.label }}
                </SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div
            v-if="showPackageSelector"
            class="flex flex-col gap-[0.42rem]"
          >
            <span
              class="text-[0.75rem] font-extrabold uppercase tracking-[0.08em] text-[#748197]"
            >
              Package
            </span>
            <Select
              :model-value="
                filters.package_id === null ? '' : String(filters.package_id)
              "
              @update:model-value="onPackageUpdate"
            >
              <SelectTrigger
                class="min-h-12 rounded-[0.95rem] border-[rgba(211,220,233,1)] bg-[#fdfefe] px-[0.9rem] py-[0.82rem] text-[0.95rem] text-[#243049] shadow-[inset_0_1px_0_rgba(255,255,255,0.85)] focus:ring-[#8eb4ff] focus:ring-offset-0"
              >
                <SelectValue placeholder="All Packages" />
              </SelectTrigger>
              <SelectContent
                class="rounded-[0.95rem] border-[rgba(211,220,233,1)] bg-white text-[#243049] shadow-[0_20px_45px_rgba(15,23,42,0.12)]"
              >
                <SelectItem value="__all_packages">
                  All Packages
                </SelectItem>
                <SelectItem
                  v-for="pkg in packageOptions"
                  :key="pkg.value"
                  :value="pkg.value"
                >
                  {{ pkg.label }}
                </SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div class="flex flex-col gap-[0.42rem]">
            <span
              class="text-[0.75rem] font-extrabold uppercase tracking-[0.08em] text-[#748197]"
            >
              Date From
            </span>
            <Input
              :model-value="filters.date_from ?? ''"
              type="date"
              :min="dateFromMin || undefined"
              class="min-h-12 rounded-[0.95rem] border-[rgba(211,220,233,1)] bg-[#fdfefe] px-[0.9rem] py-[0.82rem] text-[0.95rem] text-[#243049] placeholder:text-[#8a95a9] focus-visible:ring-[#8eb4ff] focus-visible:ring-offset-0 focus-visible:shadow-[0_0_0_4px_rgba(99,149,255,0.12)]"
              @update:model-value="onDateFromUpdate"
            />
          </div>

          <div class="flex flex-col gap-[0.42rem]">
            <span
              class="text-[0.75rem] font-extrabold uppercase tracking-[0.08em] text-[#748197]"
            >
              Date To
            </span>
            <Input
              :model-value="filters.date_to ?? ''"
              type="date"
              :min="dateFromMin || undefined"
              class="min-h-12 rounded-[0.95rem] border-[rgba(211,220,233,1)] bg-[#fdfefe] px-[0.9rem] py-[0.82rem] text-[0.95rem] text-[#243049] placeholder:text-[#8a95a9] focus-visible:ring-[#8eb4ff] focus-visible:ring-offset-0 focus-visible:shadow-[0_0_0_4px_rgba(99,149,255,0.12)]"
              @update:model-value="onDateToUpdate"
            />
          </div>
        </div>
      </div>
    </AnimatedBox>

    <Dialog v-model:open="specificAccountDialogOpen">
      <DialogContent
        class="max-h-[90vh] w-[min(92vw,44rem)] overflow-hidden rounded-[1.4rem] border border-[rgba(215,226,239,0.95)] bg-white p-0 shadow-[0_28px_80px_rgba(15,23,42,0.22)]"
      >
        <div class="border-b border-[rgba(227,233,243,0.95)] px-6 py-5">
          <DialogHeader class="gap-y-2 text-left">
            <DialogTitle class="text-[1.3rem] font-extrabold text-[#182033]">
              Select Account Report
            </DialogTitle>
            <DialogDescription class="text-[#6e7b92]">
              Choose a client account to generate a dashboard report using that
              account's dashboard data.
            </DialogDescription>
          </DialogHeader>
        </div>

        <div class="space-y-4 px-6 py-5">
          <div class="relative">
            <Search
              class="pointer-events-none absolute left-3 top-1/2 size-4 -translate-y-1/2 text-[#94a3b8]"
            />
            <Input
              v-model="specificAccountSearch"
              class="h-11 rounded-[0.95rem] border-[rgba(211,220,233,1)] bg-white pl-10 text-[0.95rem] text-[#243049] focus-visible:ring-[#8eb4ff] focus-visible:ring-offset-0"
              placeholder="Search accounts"
              type="text"
            />
          </div>

          <div class="max-h-[18rem] space-y-2 overflow-y-auto pr-1">
            <button
              v-for="client in filteredSpecificClients"
              :key="client.client_id"
              type="button"
              class="flex w-full items-start justify-between gap-3 rounded-[1rem] border px-4 py-3 text-left transition-colors"
              :class="
                selectedSpecificClientId === client.client_id
                  ? 'border-[#8eb4ff] bg-[#f4f8ff]'
                  : 'border-[rgba(216,228,240,0.95)] bg-white hover:bg-[#f8fbff]'
              "
              @click="selectedSpecificClientId = client.client_id"
            >
              <div class="min-w-0 space-y-1">
                <p
                  class="truncate text-[0.95rem] font-extrabold text-[#182033]"
                >
                  {{ client.company_name }}
                </p>
                <p class="text-[0.84rem] text-[#6e7b92]">
                  Client ID {{ client.client_id }}
                </p>
                <p
                  v-if="client.package_name"
                  class="text-[0.84rem] text-[#6e7b92]"
                >
                  Package:
                  <span class="font-semibold text-[#1b2436]">{{
                    client.package_name
                  }}</span>
                </p>
              </div>

              <Badge
                variant="outline"
                class="rounded-full border-[rgba(142,180,255,0.35)] bg-[#f6f9ff] px-2.5 py-[0.2rem] text-[0.68rem] font-extrabold uppercase tracking-[0.08em] text-[#2855a6]"
              >
                {{ client.active_services_count }} Services
              </Badge>
            </button>

            <div
              v-if="!filteredSpecificClients.length"
              class="rounded-[1rem] border border-dashed border-[rgba(216,228,240,0.95)] bg-[#fbfcff] px-4 py-5 text-center text-[0.92rem] text-[#6e7b92]"
            >
              {{
                specificAccountSearch.trim()
                  ? "No matching accounts found."
                  : "No available accounts found for report generation."
              }}
            </div>
          </div>
        </div>

        <DialogFooter
          class="border-t border-[rgba(227,233,243,0.95)] px-6 py-4"
        >
          <Button
            variant="outline"
            type="button"
            class="rounded-[0.95rem] border-[rgba(49,125,255,0.22)] bg-[#f6f9ff] px-4 py-2 font-bold text-[#2855a6] hover:bg-[#eef4ff]"
            :disabled="isReportActionBusy"
            @click="closeSpecificAccountDialog"
          >
            Cancel
          </Button>
          <Button
            type="button"
            class="rounded-[0.95rem] bg-[#1f7aff] px-4 py-2 font-bold text-white hover:bg-[#1f7aff]"
            :disabled="!selectedSpecificClientId || isReportActionBusy"
            @click="confirmSpecificAccountReport"
          >
            {{ isReportActionBusy ? "Preparing report..." : "Generate Report" }}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  </section>
</template>

<script setup lang="ts">
import { computed, ref, watch, inject } from "vue";
import {
  ChevronDown,
  Download,
  Loader2,
  RefreshCcw,
  Search,
  Calendar,
  Gem,
} from "lucide-vue-next";
import { useToast } from "vue-toast-notification";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import AnimatedBox from "@/components/dashboard/AnimatedBox.vue";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import type {
  DashboardClientOption,
  DashboardFilters,
  DashboardReportDownloadAction,
  DashboardReportDownloadPayload,
  DashboardRole,
} from "@/types/dashboard";

const props = defineProps<{
  title: string;
  subtitle: string;
  role: DashboardRole;
  filters: DashboardFilters;
  clients: DashboardClientOption[];
  serviceOptions: { label: string; value: string }[];
  packageOptions: { label: string; value: string }[];
  lastUpdated: string | null;
  showPackageSelector?: boolean;
  dateFromMin?: string | null;
  downloadLoading?: boolean;
  reportPeriod?: string | null;
  nextReportUpdate?: string | null;
  packageName?: string | null;
}>();

const emit = defineEmits<{
  (event: "update:filters", value: DashboardFilters): void;
  (event: "download-report", value: DashboardReportDownloadPayload): void;
}>();

// comfortMode removed

const reportMenuRef = ref<HTMLElement | null>(null);
const toast = useToast();
const specificAccountDialogOpen = ref(false);
const specificAccountSearch = ref("");
const selectedSpecificClientId = ref("");

const isClientUser = computed(() => props.role === "client");
const isSuperAdmin = computed(() => props.role === "super_admin");
const isAdminOrMember = computed(() =>
  ["admin", "member"].includes(props.role)
);
const showClientSelector = computed(() => !isClientUser.value);
const showPackageSelector = computed(() => props.showPackageSelector ?? true);
const showReportMenu = computed(
  () => isSuperAdmin.value || isAdminOrMember.value
);
const isReportActionBusy = computed(() => Boolean(props.downloadLoading));

const reportActions = computed(() => {
  if (isSuperAdmin.value) {
    return [
      { value: "all", label: "All Accounts", hint: "ALL" },
      { value: "specific", label: "Specific Account", hint: "SPECIFIC" },
    ];
  }

  if (isAdminOrMember.value) {
    return [
      {
        value: "assigned",
        label: "All Assigned Accounts",
        hint: "ASSIGNED",
      },
      { value: "specific", label: "Specific Account", hint: "SPECIFIC" },
    ];
  }

  return [];
});

const filteredSpecificClients = computed(() => {
  const term = specificAccountSearch.value.trim().toLowerCase();
  return props.clients
    .filter((client) => {
      if (!term) return true;
      return [client.company_name, client.client_id, client.package_name]
        .filter(Boolean)
        .some((value) => String(value).toLowerCase().includes(term));
    })
    .slice()
    .sort((a, b) => a.company_name.localeCompare(b.company_name));
});

const selectedSpecificClient = computed(() =>
  props.clients.find(
    (client) => client.client_id === selectedSpecificClientId.value
  )
);

const formattedLastUpdated = computed(() => {
  if (!props.lastUpdated) return "Not yet refreshed";
  return new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  }).format(new Date(props.lastUpdated));
});

function updateFilter<K extends keyof DashboardFilters>(
  key: K,
  value: DashboardFilters[K]
) {
  emit("update:filters", {
    ...props.filters,
    [key]: value,
  });
}

function onClientUpdate(value: string | number) {
  updateFilter("client_id", value ? String(value) : "all");
}

function onServiceUpdate(value: string | number) {
  updateFilter(
    "service_id",
    value && value !== "__all_services" ? Number(value) : null
  );
}

function onPackageUpdate(value: string | number) {
  updateFilter(
    "package_id",
    value && value !== "__all_packages" ? Number(value) : null
  );
}

function onDateFromUpdate(value: string | number) {
  const nextValue = value ? String(value) : null;
  if (!nextValue || !props.dateFromMin) {
    updateFilter("date_from", nextValue);
    return;
  }

  updateFilter(
    "date_from",
    nextValue < props.dateFromMin ? props.dateFromMin : nextValue
  );
}

function onDateToUpdate(value: string | number) {
  const nextValue = value ? String(value) : null;
  if (!nextValue || !props.dateFromMin) {
    updateFilter("date_to", nextValue);
    return;
  }

  updateFilter(
    "date_to",
    nextValue < props.dateFromMin ? props.dateFromMin : nextValue
  );
}

function emitDownloadReport(
  action: DashboardReportDownloadAction,
  clientId: string | null = null
) {
  reportMenuRef.value?.removeAttribute("open");

  emit("download-report", {
    action,
    client_id: clientId,
    role: props.role,
    filters: {
      ...props.filters,
      client_id:
        action === "specific" && clientId ? clientId : props.filters.client_id,
    },
  });
}

function handleDownloadReportClick() {
  if (isReportActionBusy.value) return;

  if (isClientUser.value) {
    emitDownloadReport("current", null);
    return;
  }

  toast.error("Unable to open report. Please try again.");
}

function openSpecificAccountSelector() {
  if (!filteredSpecificClients.value.length) {
    toast.error("No available accounts found for report generation.");
    return;
  }

  specificAccountSearch.value = "";
  selectedSpecificClientId.value = "";
  specificAccountDialogOpen.value = true;
}

function closeSpecificAccountDialog() {
  specificAccountDialogOpen.value = false;
}

function confirmSpecificAccountReport() {
  if (!selectedSpecificClient.value) {
    toast.error("Please select a client account first.");
    return;
  }

  specificAccountDialogOpen.value = false;
  emitDownloadReport("specific", selectedSpecificClient.value.client_id);
}

function handleReportMenuAction(value: DashboardReportDownloadAction) {
  if (isReportActionBusy.value) return;

  if (value === "all" && isSuperAdmin.value) {
    emitDownloadReport("all", null);
    return;
  }

  if (value === "assigned" && isAdminOrMember.value) {
    emitDownloadReport("assigned", null);
    return;
  }

  if (value === "specific" && (isSuperAdmin.value || isAdminOrMember.value)) {
    openSpecificAccountSelector();
    return;
  }

  if (value === "current" && isClientUser.value) {
    emitDownloadReport("current", null);
    return;
  }

  toast.error("Unable to open report. Please try again.");
}

watch(specificAccountDialogOpen, (open) => {
  if (!open) {
    specificAccountSearch.value = "";
    selectedSpecificClientId.value = "";
  }
});
</script>

<style scoped>
summary {
  list-style: none;
}

summary::-webkit-details-marker {
  display: none;
}
</style>
